<template>
	<div class="our-services">
		<div class="our-services__header">
			<h2>What We Do</h2>
		</div>

		<div class="our-services__grid">
			<div
				v-for="(service, i) in mainServices"
				:key="i"
				class="our-services__item"
			>
				<h3>{{ service.title }}</h3>
				<p>{{ service.text }}</p>
			</div>
		</div>

		<div class="our-services__trades">
			<h3 class="our-services__trades-title">Every trade handled under one roof</h3>
			<ul class="our-services__chips">
				<li v-for="trade in trades" :key="trade" class="our-services__chip">{{ trade }}</li>
			</ul>
			<p class="our-services__note">Permits, inspections and licensed electricians and plumbers included.</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OurServices',

	data() {
		return {
			mainServices: [
				{
					title: 'Kitchen Remodeling',
					text:  'Custom cabinetry, countertops, lighting and layout changes, designed around how you cook and gather.',
				},
				{
					title: 'Bathroom Remodeling',
					text:  'Tile, vanities, walk-in showers and fixtures, from design through final walkthrough.',
				},
				{
					title: 'Whole-Home Renovation',
					text:  'Open up floor plans and refresh every room, with one team managing the entire project.',
				},
			],
			trades: [
				'Painting',
				'Hardwood & Tile Flooring',
				'Drywall & Trim',
				'Stairs & Railings',
				'Structural Changes',
				'Electrical',
				'Plumbing',
			],
		};
	},
};
</script>

<style lang="scss" scoped>
.our-services {
	padding: 0 30px;
	margin: 40px 0;

	@media (max-width: 768px) { padding: 0 15px; margin: 25px 0; }
}

// ─── HEADER ──────────────────────────────────────────────
// .our-services__header {
// 	margin-bottom: 28px;
// }

h2 {
	font-size: 42px;
	font-weight: 500;
	color: #191919;
	margin: 0;
	line-height: 1.1;

	@media (max-width: 768px) { font-size: 28px; }
}

// ─── GRID (как .why__grid в HomeView.vue) ────────────────
.our-services__grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 2px;
	background: rgba(0, 0, 0, 0.07);
	border-radius: 20px;
	overflow: hidden;

	@media (max-width: 900px) { grid-template-columns: 1fr; }
}

// ─── ITEM (как .why__item) ───────────────────────────────
.our-services__item {
	background: #ffffff;
	padding: 30px 26px;
	display: flex;
	flex-direction: column;
	gap: 14px;

	@media (max-width: 900px) { padding: 15px 10px; }

	h3 {
		font-size: 22px;
		font-weight: 600;
		color: #191919;
		margin: 0;
		line-height: 1.25;

		@media (max-width: 900px) { font-size: 20px; }
	}

	p {
		font-size: 16px;
		color: rgba(25, 25, 25, 0.8);
		line-height: 1.6;
		margin: 0;

		@media (max-width: 900px) { font-size: 15px; }
	}
}

// ─── OTHER TRADES ────────────────────────────────────────
.our-services__trades {
	margin-top: 15px;
}

.our-services__trades-title {
	font-size: 18px;
	font-weight: 600;
	color: #191919;
	margin: 0 0 14px;
	line-height: 1.25;
}

// чипы в стиле .portfolio__filter (PortfolioView.vue), но не интерактивные
.our-services__chips {
	display: flex;
	flex-wrap: wrap;
	gap: 5px;
	list-style: none;
	margin: 0;
	padding: 0;
}

.our-services__chip {
	display: inline-flex;
	align-items: center;
	max-width: 100%;
	padding: 8px 18px;
	border-radius: 100px;
	border: 1px solid rgba(0, 0, 0, 0.12);
	background: #ffffff;
	font-size: 13px;
	font-weight: 500;
	color: rgba(25, 25, 25, 0.8);
	line-height: 1.3;
	overflow-wrap: anywhere;
}

.our-services__note {
	margin: 14px 0 0;
	font-size: 14px;
	color: #6b6b6b;
	line-height: 1.5;
}
</style>
